import { FC, Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Navbar from '@/components/navbar';
import { useGetCurrentUser } from '@/hooks/auth';
import SideNav from '@/components/sidenav';
import '@/lib/language-selector';
import Loading from '@/components/loading';
import { useGetAppConfig } from '@/hooks/appConfig';

const AppLayout: FC = () => {
  const location = useLocation()
  const path = location.pathname

  const fullWidth = useMemo(() => {
    let fullscreen: boolean = false
    const fullWidthRoutes: RegExp[] = [
      new RegExp('^/admin/questionnaire/.+/.+')
    ]

    for (const r of fullWidthRoutes)
      if (r.test(path))
        fullscreen = true
      
    return fullscreen
  }, [path])

  useGetCurrentUser();
  useGetAppConfig();

  return (
    <main className="flex w-screen relative bg-inherit">
      <div className="h-full min-h-screen fixed z-30">
        <SideNav />
      </div>
      <div className="h-16 fixed top-0 w-full pl-16 z-20 bg-inherit">
        <Navbar />
      </div>
      <section className="flex min-h-screen flex-col overflow-hidden w-full text-base py-16 pl-16">
        <div id="content-menu"></div>
        <div 
          className={`${fullWidth ? 'w-[calc(100vw-62px)]' : 'container'} mx-auto flex-1`}>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </div>
      </section>
    </main>
  );
};

export default AppLayout;
